enum ConfluencePages {
  COMPANIES = '43712525',
  DASHBOARD = '43319347',
  DEVICES = '43614211',
  MANUFACTURING = '43581444',
  PROJECTS = '43286580',
  PRIVACY_POLICY = '47939613',
  RUUVI_TAGS = '43122744',
  USERS = '43614229',
  USER_MANUAL = '294913',
  TERMS_OF_SERVICE = '45711364',
  AUTH_SIGN_IN = '99024897',
  CHANGELOG = '68419602',

  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_FI = '315654156',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_SE = '316112906',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_NO = '315916306',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_EN = '314736682',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_DE = '315817988',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_ES = '315883532',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_FR = '315129888',
  VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_NL = '315752476',

  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_FI = '315392001',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_SE = '315752449',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_NO = '314933250',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_EN = '315621377',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_DE = '315916289',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_ES = '315686914',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_FR = '315949057',
  VALVE_ATTACH_IN_RUUVITAG_INSTRUCTIONS_NL = '315981825',

  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_FI = '314703884',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_SE = '315162626',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_NO = '315162633',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_EN = '315523076',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_DE = '315097101',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_ES = '314736658',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_FR = '316243969',
  VALVE_ATTACH_OUT_RUUVITAG_INSTRUCTIONS_NL = '316276737'
}

export default ConfluencePages
